import React, { useState } from 'react';
import { Button, Tooltip, CircularProgress, IconButton } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import RefreshIcon from '@mui/icons-material/Refresh';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import BoltIcon from '@mui/icons-material/Bolt';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddShoppingCartOutlinedIcon from '@mui/icons-material/AddShoppingCartOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import { chayNutDong, nutDongHienO, nutDongHopLeVoi } from './nutChucNangDanhSach';

/**
 * NÚT TUỲ CHỈNH CỦA TỪNG DÒNG (`rowActions` trong data_list_config) — vẽ ở cột "Thao tác" của danh sách (bảng / thẻ / gọn) và
 * trên thanh nút của màn hình xem (DataView). Vd danh mục Lead: "Tạo cơ hội", "Tạo đơn hàng".
 *
 *   noi = 'list' : nút biểu tượng nhỏ (tên ở tooltip) cạnh Xem / Sửa / Xoá — cột Thao tác hẹp.
 *   noi = 'view' : nút có chữ — màn hình xem rộng, và người dùng cần đọc được nút làm gì.
 *
 * Bấm không làm "bấm dòng" (stopPropagation): ở chế độ bảng, bấm dòng là mở khung chi tiết. Chỉ một nút chạy một lúc trong
 * cùng một dòng — nút thường gọi máy chủ rồi mở form, bấm hai lần là hai form chồng nhau.
 */
export const BIEU_TUONG_DONG = {
  sync: SyncIcon, refresh: RefreshIcon, download: FileDownloadOutlinedIcon, upload: FileUploadOutlinedIcon,
  send: SendOutlinedIcon, play: PlayArrowIcon, bolt: BoltIcon,
  add: AddCircleOutlineIcon, cart: AddShoppingCartOutlinedIcon, handshake: HandshakeOutlinedIcon, open: OpenInNewIcon, chat: ChatOutlinedIcon,
};
// Màu nền nhạt cho nút biểu tượng — cùng kiểu với Xem / Sửa / Xoá của cột Thao tác.
const MAU = {
  primary: ['#1565c0', '#e3f2fd'], success: ['#2e7d32', '#e8f5e9'], warning: ['#ef6c00', '#fff3e0'],
  error: ['#c62828', '#ffebee'], secondary: ['#6a1b9a', '#f3e5f5'], info: ['#0277bd', '#e1f5fe'],
};

export default function DataRowActions({ actions, item, noi = 'list', layThamSo, context, onXong }) {
  const [dangChay, setDangChay] = useState('');
  // `showIfField`: nút chỉ có ý nghĩa với một số bản ghi (vd "Mở hội thoại" — bản ghi tạo từ khung chat).
  const ds = (Array.isArray(actions) ? actions : []).filter((nut) => nut && nutDongHienO(nut, noi) && nutDongHopLeVoi(nut, item));
  if (!ds.length || !item) return null;

  const bao = (msg, mau) => { if (msg && context && context.alert) context.alert(msg, null, mau); };
  const bam = (e, nut, khoa) => {
    if (e && e.stopPropagation) e.stopPropagation();
    if (dangChay) return;
    const chay = async () => {
      setDangChay(khoa);
      try {
        // Tham số lấy NGAY LÚC BẤM (bản ghi của dòng có thể vừa được nạp lại).
        const kq = await chayNutDong(nut, layThamSo ? layThamSo(item) : { item });
        bao(kq.message, kq.color);
        if (kq.refresh && onXong) onXong(item);
      } finally {
        setDangChay('');
      }
    };
    if (nut.confirm && context && context.alert) context.alert(nut.confirm, (yes) => { if (yes) chay(); });
    else chay();
  };

  return (
    <React.Fragment>
      {ds.map((nut, i) => {
        const khoa = nut.code || String(i);
        const Icon = BIEU_TUONG_DONG[String(nut.icon || '').toLowerCase()] || null;
        const dang = dangChay === khoa;
        const [mauChu, mauNen] = MAU[nut.color] || MAU.primary;
        if (noi === 'list') {
          return (
            <Tooltip key={khoa} title={nut.tooltip || nut.label || ''}>
              <span style={{ display: 'inline-flex' }}>
                {Icon ? (
                  <IconButton size="small" aria-label={nut.label} onClick={(e) => bam(e, nut, khoa)} disabled={!!dangChay}
                    sx={{ color: mauChu, bgcolor: mauNen, p: 0.5 }}>
                    {dang ? <CircularProgress size={16} color="inherit" /> : <Icon sx={{ fontSize: 16 }} />}
                  </IconButton>
                ) : (
                  // Không khai biểu tượng: vẫn phải đọc được — một ô trống trơn thì không ai dám bấm.
                  <Button size="small" variant="outlined" onClick={(e) => bam(e, nut, khoa)} disabled={!!dangChay}
                    sx={{ minWidth: 0, px: 0.75, py: 0, fontSize: 11, lineHeight: 1.6, whiteSpace: 'nowrap', color: mauChu, borderColor: mauNen }}>
                    {dang ? <CircularProgress size={12} color="inherit" /> : nut.label}
                  </Button>
                )}
              </span>
            </Tooltip>
          );
        }
        return (
          <Tooltip key={khoa} title={nut.tooltip || ''}>
            <span style={{ display: 'inline-flex' }}>
              <Button size="small" variant={nut.variant || 'outlined'} color={MAU[nut.color] ? nut.color : 'primary'}
                onClick={(e) => bam(e, nut, khoa)} disabled={!!dangChay}
                startIcon={dang ? <CircularProgress size={14} color="inherit" /> : (Icon ? <Icon fontSize="small" /> : null)}
                sx={{ whiteSpace: 'nowrap', textTransform: 'none' }}>
                {nut.label}
              </Button>
            </span>
          </Tooltip>
        );
      })}
    </React.Fragment>
  );
}
